
import { Component, Prop, Vue } from 'vue-property-decorator';

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { schedule3DataInfoType, undueHardshipDetailsInfoType, schedule4DataInfoType } from '@/types/Application/ReplyFamilyLawMatter/Pdf';
import { disagreeChildSupportDataInfoType, relationshipToChildDataInfoType, rflmCalculatingChildSupportDataInfoType, replyExistingChildSupportDataInfoType,rflmUnpaidChildSupportDataInfoType,disagreeExistingChildSupportDataInfoType } from '@/types/Application/ReplyFamilyLawMatter/ChildSupport';
import { undueHardshipDataInfoType } from '@/types/Application/FamilyLawMatter/ChildSupport';
import { rflmAdditionalDocsDataInfoType } from '@/types/Application/ReplyFamilyLawMatter';
import GreyBoxForm from '@/components/utils/PopulateForms/components/GreyBoxForm.vue';
import ScheduleHeader from '@/components/utils/PopulateForms/components/ScheduleHeader.vue';
import FormPart from '@/components/utils/PopulateForms/components/FormPart.vue';
import NoteBox from '@/components/utils/PopulateForms/components/NoteBox.vue';

@Component({
    components:{
        UnderlineForm,
        CheckBox,
        GreyBoxForm,
        ScheduleHeader,
        FormPart,
        NoteBox
    }
})
export default class Schedule3 extends Vue {

    @Prop({required:true})
    result!: any;
   
    dataReady = false;   
    chSupInfo = {} as schedule3DataInfoType;
    exChSupInfo = {} as schedule4DataInfoType;
    
   
    mounted(){
        this.dataReady = false;
        this.extractInfo();       
        this.dataReady = true;
    } 

    public extractInfo(){
        this.chSupInfo = this.getNewChildSupportInfo();
        this.exChSupInfo = this.getExistingChildSupportInfo();
        
    }

    public getNewChildSupportInfo(){       
       
        let newChildSupportInfo = {} as schedule3DataInfoType;

        if (this.result.relationshipToChildSurvey){
            const relationshipInfo: relationshipToChildDataInfoType = this.result.relationshipToChildSurvey
            newChildSupportInfo.appType = {
                parent: relationshipInfo.listOfRelationshipTypes.includes('parent'),
                notParent: relationshipInfo.listOfRelationshipTypes.includes('notParent'),
                standing: relationshipInfo.listOfRelationshipTypes.includes('stepParent'),
                parentageTestReq: relationshipInfo.listOfRelationshipTypes.includes('notParent') && relationshipInfo.parentageTest == 'y',
                notStanding: relationshipInfo.listOfRelationshipTypes.includes('notStepParent')
            }
           
        } else {
            newChildSupportInfo.appType = {
                parent: false,
                notParent: false,
                standing: false,
                parentageTestReq: false,
                notStanding: false
            } 
        }

        if (this.result.disagreeChildSupportSurvey){
            const disagreeInfo: disagreeChildSupportDataInfoType = this.result.disagreeChildSupportSurvey;

            let undueHardshipDetailsInfo = {} as undueHardshipDetailsInfoType

            if (disagreeInfo.causeUndueHardship == "true"){
                undueHardshipDetailsInfo = {
                    debt: disagreeInfo.undueHardshipReason.includes('debt'),
                    highExpense: disagreeInfo.undueHardshipReason.includes('expenses'),
                    legalDutyOtherPerson: disagreeInfo.undueHardshipReason.includes('legalDutyOtherPerson'),
                    legalDutyOtherChild: disagreeInfo.undueHardshipReason.includes('legalDutyOtherChild'),
                    otherHardship: disagreeInfo.undueHardshipReason.includes('other'),
                    otherHardshipDesc: disagreeInfo.undueHardshipReason.includes('other')?disagreeInfo.undueHardshipReasonComment:''   
                }

            } else {

                undueHardshipDetailsInfo = {
                    debt: false,
                    highExpense: false,
                    legalDutyOtherPerson: false,
                    legalDutyOtherChild: false,
                    otherHardship: false,
                    otherHardshipDesc: ''   
                }

            }

            newChildSupportInfo.disagreeReason = {
                appIncome: disagreeInfo.incorrectIncome == "true",                
                opIncome: disagreeInfo.incorrectOpIncome == "true",
                opIncomeDesc: disagreeInfo.incorrectOpIncome == "true"?disagreeInfo.incorrectDescription:'',
                specialExpense: disagreeInfo.incorrectSpecialAndExtraordinaryExpenses == "true",
                specialExpenseDesc: disagreeInfo.incorrectSpecialAndExtraordinaryExpenses == "true"?disagreeInfo.incorrectSpecialAndExtraordinaryDescription:'',
                livingArrangements: disagreeInfo.incorrectTimeWithChild == "true",
                livingArrangementsDesc: disagreeInfo.incorrectTimeWithChild == "true"?disagreeInfo.incorrectTimeWithChildDescription:'',   
                undueHardship: disagreeInfo.causeUndueHardship == "true",
                undueHardshipDetails: undueHardshipDetailsInfo,
                other: disagreeInfo.disagreeOtherReason == 'y',
                otherDesc: disagreeInfo.disagreeOtherReason == 'y'? disagreeInfo.OtherReasonDescription:''
            }

        } else {

            const undueHardshipDetailsInfo = {
                debt: false,
                highExpense: false,
                legalDutyOtherPerson: false,
                legalDutyOtherChild: false,
                otherHardship: false,
                otherHardshipDesc: ''   
            }

            newChildSupportInfo.disagreeReason = {
                appIncome: false,                
                opIncome: false,
                opIncomeDesc: '',
                specialExpense: false,
                specialExpenseDesc: '',
                livingArrangements: false,
                livingArrangementsDesc: '',   
                undueHardship: false,
                undueHardshipDetails: undueHardshipDetailsInfo,
                other: false,
                otherDesc: ''
            }
        }

        if (this.result.flmAdditionalDocumentsSurvey){
            const additionalDocsInfo: rflmAdditionalDocsDataInfoType = this.result.flmAdditionalDocumentsSurvey;
        
            newChildSupportInfo.filing = additionalDocsInfo.isFilingAdditionalDocs == 'y';
        
        } else {
            newChildSupportInfo.filing = false;
        }

        if (this.result.rflmCalculatingChildSupportSurvey){
            const calculationInfo: rflmCalculatingChildSupportDataInfoType = this.result.rflmCalculatingChildSupportSurvey;
                    
            newChildSupportInfo.calculate = {                
                attaching: calculationInfo.attachingCalculations == 'y',
                reason: calculationInfo.attachingCalculations == 'n'?calculationInfo.notAttachingCalculationsReason:''
            } 
        
        } else {

            newChildSupportInfo.calculate = {                
                attaching: false,
                reason: ''
            } 

        } 
        
        return newChildSupportInfo;
    } 


public getExistingChildSupportInfo(){

let existingChildSupportInfo = {} as schedule4DataInfoType;       


if (this.result.replyExistingChildSupportSurvey && this.result.rflmUnpaidChildSupportSurvey 
        && this.result.rflmCalculatingChildSupportSurvey && this.result.disagreeExistingChildSupportSurvey){

    const replyExistingChildSupportInfo: replyExistingChildSupportDataInfoType = this.result.replyExistingChildSupportSurvey;
    if (replyExistingChildSupportInfo.existingType == 'finalOrder'){
        existingChildSupportInfo.agreeCircumstanceChanges = replyExistingChildSupportInfo.agreeFinalOrder == 'y';
        existingChildSupportInfo.disAgreeCircumstanceChanges = replyExistingChildSupportInfo.agreeFinalOrder == 'n';
        existingChildSupportInfo.section150 = false;
        existingChildSupportInfo.agreeSetAside = false;

    } else if (replyExistingChildSupportInfo.existingType == 'agreement'){
        existingChildSupportInfo.section150 = replyExistingChildSupportInfo.agreeAgreement == 'y';
        existingChildSupportInfo.agreeSetAside = replyExistingChildSupportInfo.agreeAgreement == 'n';
        existingChildSupportInfo.agreeCircumstanceChanges = false;
        existingChildSupportInfo.disAgreeCircumstanceChanges = false;
    }

    const rflmUnpaidChildSupportInfo: rflmUnpaidChildSupportDataInfoType = this.result.rflmUnpaidChildSupportSurvey;

    existingChildSupportInfo.unpaidDetails = {
        agreeAmount: rflmUnpaidChildSupportInfo.agreeChildSupportAmount == 'y',
        crntDate: rflmUnpaidChildSupportInfo.agreeChildSupportAmount == 'n'? Vue.filter('beautify-date')(rflmUnpaidChildSupportInfo.calculationDate):'',
        unpaidAmnt: rflmUnpaidChildSupportInfo.agreeChildSupportAmount == 'n'?rflmUnpaidChildSupportInfo.unPaidAmount:''

    }           
    const calculationInfo: rflmCalculatingChildSupportDataInfoType = this.result.rflmCalculatingChildSupportSurvey;
            
    existingChildSupportInfo.calc = {                
        attaching: calculationInfo.attachingCalculations == 'y',
        reason: calculationInfo.attachingCalculations == 'n'?calculationInfo.notAttachingCalculationsReason:''
    } 

    const disagreeExistingChildSupportInfo: disagreeExistingChildSupportDataInfoType = this.result.disagreeExistingChildSupportSurvey;

    existingChildSupportInfo.disagreeReason = disagreeExistingChildSupportInfo.disagreeReason;
    existingChildSupportInfo.continue = disagreeExistingChildSupportInfo.requestedOrder == 'noChange';
    existingChildSupportInfo.change = disagreeExistingChildSupportInfo.requestedOrder == 'diffChange';
    existingChildSupportInfo.changeExpl = disagreeExistingChildSupportInfo.requestedOrder == 'diffChange'?disagreeExistingChildSupportInfo.requestedChangeDescription:'';  
    
  
} else {
    const calculationsInfo = {
        attaching: false,
        reason: ''
    }
    const childSupportUnpaid = {
        agreeAmount: false,
        crntDate: '',
        unpaidAmnt: ''
    }
    existingChildSupportInfo = {
    
        agreeCircumstanceChanges: false,
        disAgreeCircumstanceChanges: false,
        agreeSetAside: false,
        section150: false,
        disagreeReason: '',
        continue: false,  
        change: false,
        changeExpl: '',     
        calc: calculationsInfo,
        unpaidDetails: childSupportUnpaid
    }    

}

        

return existingChildSupportInfo;
} 
}
